"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENDPOINTS = void 0;
exports.ENDPOINTS = {
    DATA_ANALYTICS_DETAILS_URL: '/auth/xrg/api/v1/registration/dataanalytics/analyticsdetails',
    LOGGED_ON_STATUS: '/fasdigital/user-status',
    SCRAMBLE_POID: '/auth/xrg/api/v1/registration/scramblePoid/details',
    RTE_LEVEL: '/auth/xrg/public/registration/rtelevel'
};
//# sourceMappingURL=endpoints.constant.js.map